// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import getEvents from './event';
class BaseClass {
    constructor(options = {}) {
        this.options = options
        this.debug = options.debug || false
    }

    setOptions(options) {
        Object.assign(this.options, options)
    }
  
    get events() {
        if (this.options && this.options.events) {
            return this.options.events(this)
        }
        return getEvents(this)
    }
    get alert() {
        let res = ''
        if (this.options && this.options.alertError) {
            res = this.options.alertError
        }
        return res
    }

    toString() {
        return JSON.stringify(this)
    }
}

export default BaseClass